import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDashboardComponent } from "./med-icon-dashboard.component";

@NgModule({
  declarations: [
    MedIconDashboardComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDashboardComponent,
  ],
})
export class MedIconDashboardModule { }
